(function($) {
	$(document).foundation();
}) (jQuery);